(function($) {
	$(document).foundation();
}) (jQuery);